import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const MultiColumnIcon: React.FC<AddIconProps> = ({ size = 22, color = '#0556CB', className, onClick }) => (
  <svg width="93" height="32" viewBox="0 0 99 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="41" height="6" rx="1" fill={color} fillOpacity="0.3" />
    <rect y="11" width="45" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect y="15" width="45" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect y="19" width="45" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect y="26" width="25" height="6" rx="1" fill={color} fillOpacity="0.3" />
    <rect x="53.3096" width="41" height="6" rx="1" fill={color} fillOpacity="0.3" />
    <rect x="53.3096" y="11" width="45" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect x="53.3096" y="15" width="45" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect x="53.3096" y="19" width="45" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect x="53.3096" y="26" width="25" height="6" rx="1" fill={color} fillOpacity="0.3" />
  </svg>


);

export default MultiColumnIcon;
